import React from "react";
import EventDetailItem from "./eventDetailItem";
import SvgClockIcon from "./icons/SvgClockIcon";
import SvgLocationIcon from "./icons/SvgLocationIcon";
import SvgMonyIcon from "./icons/SvgMonyIcon";
import ProductPrice from "../ProductPrice";
import calculatPricesForSpecialPrices from "@/utils/functions/calculatPriceForSpecialPrices";
import {
  DiscountTypes,
  ISelling_Prices,
} from "@/api/AppApi/services/home/interfaces/IProduct";
import SvgCalenderIcon from "./icons/SvgCalenderIcon";
import {
  EventLocationType,
  IEventCustomData,
} from "@/api/AppApi/services/home/IEvent";

interface Props extends IEventCustomData {
  price: number;
  price_without_discount: number;
  special_prices: ISelling_Prices[];
  discount_amount: number;
  discount_type?: DiscountTypes;
  discount?: number;
}
const EventCustomData: React.FC<Props> = ({
  price: originalPrice,
  price_without_discount,
  special_prices,
  start_date,
  start_time,
  location_type,
  location_detail,
  discount_amount,
  discount_type,
  discount,
}) => {
  const quantity = 0;
  const { price, price_without_discount: priceWithoutDiscount } =
    calculatPricesForSpecialPrices({
      originalPrice,
      originalPriceWithoutDiscount: price_without_discount,
      originalDiscountAmount: discount_amount,
      originalDiscountType: discount_type,
      originalDiscount: discount,
    })({ quantity, specialPrices: special_prices });

  const date = start_date;
  const time = start_time;
  const location =
    location_type === EventLocationType.physical ? location_detail! : "Online";

  return (
    <div className="event-box-details">
      <div className="details-row">
        <EventDetailItem icon={<SvgCalenderIcon />} title={date} />
        <EventDetailItem icon={<SvgClockIcon />} title={time} />
      </div>
      <div className="details-row">
        <EventDetailItem
          icon={<SvgMonyIcon />}
          title={
            <ProductPrice
              priceWithoutDiscount={priceWithoutDiscount}
              price={price}
              sameLine={!(special_prices || []).length}
            />
          }
        />
      </div>
      <div className="details-row">
        <EventDetailItem icon={<SvgLocationIcon />} title={location} />
      </div>
    </div>
  );
};

export default EventCustomData;
